import { notify } from '@shared/hooks';

export const displaySuccessForOfflineAction = (
  message = 'You are offline. We will save your changes when you are back online!',
) => {
  notify('success', {
    title: message,
  });
};
